import { useMemo, useState } from 'react';

import { FormattedMessage } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import RefreshIcon from '@atlaskit/icon/core/refresh';

import { messages } from '../messages';
import { resetDemo } from '../state/actions';
import { useAppDispatch } from '../state/hook';

export const RestartButton = () => {
	const dispatch = useAppDispatch();
	const [demoAttempt, setDemoAttempt] = useState(0);
	const payload = useMemo(() => resetDemo(), []);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onRestartClick = () => {
		createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'interactiveRoadmapRestartDemo',
			eventType: 'ui',
			demoAttempt,
		}).fire();
		setDemoAttempt(demoAttempt + 1);
		dispatch(payload);
		return;
	};

	return (
		<Button
			appearance="subtle-link"
			iconAfter={<RefreshIcon label="" />}
			testId="reset-demo-btn"
			onClick={onRestartClick}
		>
			{<FormattedMessage {...messages.restartButton} />}
		</Button>
	);
};
